import fetcher from '../../helpers/fetcher';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import { API_ENDPOINTS } from '../../constants/apiEndpoints';
import { unwrapDataResponse } from '../../utils/unwrapDataResponse';
import { Establishment } from '../../types/establishmentType';

class EstablishmentService {
  private consumerPriceUrl = ENVIRONMENT_CONFIG.CONSUMER_PRICE_SERVICE;

  async getEstablishments(): Promise<Establishment[]> {
    const response = await fetcher.get(
      API_ENDPOINTS.ESTABLISHMENT.GET_ESTABLISHMENT_LIST,
      undefined,
      undefined,
      this.consumerPriceUrl
    );

    return unwrapDataResponse<Establishment[]>(response.data);
  }
}

export const establishmentService = new EstablishmentService();
